module.exports = __webpack_public_path__ + "img/phone-call.f940f317.png";